import { styled } from 'styled-components';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { PlayContainer } from '../../components/PlayContainer/PlayContainer';
import { getTopicBackground } from '../Topic/TopicPage.styles';
export const Container = styled(PlayContainer).withConfig({
  displayName: "ShowBroadcastPagestyles__Container",
  componentId: "sc-uqrb1f-0"
})(["&:before{z-index:-1;width:100%;height:572px;position:absolute;content:'';background:", ";", "{margin-top:-24px;}}"], ({
  topicUrn = ''
}) => getTopicBackground(topicUrn, 0.2), Viewports.for('largeUp'));
export const TitleContainer = styled.div.withConfig({
  displayName: "ShowBroadcastPagestyles__TitleContainer",
  componentId: "sc-uqrb1f-1"
})(["margin-top:24px;"]);
export const Content = styled.div.withConfig({
  displayName: "ShowBroadcastPagestyles__Content",
  componentId: "sc-uqrb1f-2"
})(["display:flex;flex-direction:column;align-items:flex-start;margin:14px 0 0 0;", "{margin:22px 0 0 0;}> div{width:100%;}"], Viewports.for('mediumUp'));